<div class="item" *ngFor="let item of ticketsList" (click)="selectTicket(item)" [ngClass]="{'selected' : selectedItemId === item.id}">
  <div class="assignee">
    <ng-container>
      <img *ngIf="item?.assignee && item?.assignee?.profileImg" class="home365-profile-image"  matTooltip="{{item?.assignee?.fullName}}"
      matTooltipClass="home365-mat-tooltip-black" matTooltipPosition="below"  [src]="item?.assignee?.profileImg" alt="">
      <span *ngIf="item?.assignee && !item?.assignee?.profileImg && item?.assignee?.fullName" class="home365-profile-image no-image"  matTooltip="{{item?.assignee?.fullName}}"
      matTooltipClass="home365-mat-tooltip-black" matTooltipPosition="below">{{getUserInitialsFromName(item?.assignee?.fullName)}}</span>
      <img *ngIf="!item?.assignee" class="home365-profile-image"  src="./assets/img/no-profile-icon.png" alt="">
    </ng-container>
  </div>
  <div class="ticketData">
    <div class="header">
      <span class="rounded-and-filled ticket-status {{item?.displayStatus?.statusClass}}">{{item?.displayStatus?.text}}</span>
      <div class="date">
        {{item?.lastUpdate | date : 'M/dd/yyyy'}}
      </div>
    </div>
    <div class="ticketCategory">
      <div>{{item.category}}</div>
      <div class="date">
        #{{item?.ticketNumber}}
      </div>
    </div>
    <div class="ticketDescriptionContainer">
      <div class="description">{{editDescription(item.description)}}</div> 
      <div class="unSeenIcon" *ngIf="item.unSeenMessages > 0"><i class="fa-sharp fa-solid fa-circle"></i></div>
    </div>
  </div>
</div>

